module.exports = __webpack_public_path__ + "stylesheets/user-notification_dd028af2c6ec5e090a500b2141c6cff0.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/notification/user-notification.less
// module id = vkeZ
// module chunks = 154